module.exports = __webpack_public_path__ + "img/rg.c9f6cc12.png";